import { Divider, Row, Space, Typography } from 'antd';
import { FilterDropdownProps } from 'antd/es/table/interface';
import Button from 'modules/common/components/Button';
import Checkbox from 'modules/common/components/Checkbox';
import { FC } from 'react';

import styles from './styles.module.scss';

import { getTranslation } from '../../../../utils/getTranslation';

type PropTypes = {
  productCategoriesFilters: {
    text: string;
    value: string;
  }[];
} & FilterDropdownProps;

export const OutcomeFilterDropdown: FC<PropTypes> = ({
  selectedKeys = [],
  setSelectedKeys,
  confirm,
  clearFilters,
  productCategoriesFilters,
}) => {
  const t = getTranslation('donation.DonationsTable.OutcomeFilterDropdown');

  const keys = selectedKeys as string[];

  const toggleKey = (key: string) => {
    const nextKeys = keys.includes(key)
      ? keys.filter((k) => k !== key)
      : [...keys, key];
    setSelectedKeys(nextKeys);
  };

  return (
    <div className={styles.dropdownWrapper}>
      <div className={styles.filterLabel}>{t('status')}</div>
      <Space direction="vertical">
        <Checkbox
          className={styles.checkbox}
          checked={keys.includes('ineligible')}
          onChange={() => toggleKey('ineligible')}
        >
          <Typography.Text>{t('ineligible')}</Typography.Text>
        </Checkbox>
        <Checkbox
          className={styles.checkbox}
          checked={keys.includes('failed')}
          onChange={() => toggleKey('failed')}
        >
          <Typography.Text>{t('failed')}</Typography.Text>
        </Checkbox>
        <Checkbox
          className={styles.checkbox}
          checked={keys.includes('discarded')}
          onChange={() => toggleKey('discarded')}
        >
          <Typography.Text>{t('discarded')}</Typography.Text>
        </Checkbox>
      </Space>

      <Divider className={styles.divider} />

      <div className={styles.filterLabel}>{t('category')}</div>
      {productCategoriesFilters?.length === 0 ? (
        <Typography.Text type="secondary" className={styles.noCategories}>
          {t('noCategoriesFound')}
        </Typography.Text>
      ) : (
        <Space direction="vertical" className={styles.categoriesFilterWrapper}>
          {productCategoriesFilters?.map((cat) => (
            <Checkbox
              className={styles.checkbox}
              key={cat.value}
              checked={keys.includes(String(cat.value))}
              onChange={() => toggleKey(String(cat.value))}
            >
              {cat.text}
            </Checkbox>
          ))}
        </Space>
      )}

      <Divider className={styles.divider} />

      <Row justify="space-between">
        <Button
          size="small"
          onClick={() => {
            clearFilters?.();
            confirm();
          }}
        >
          {t('reset')}
        </Button>
        <Button type="primary" size="small" onClick={() => confirm()}>
          {t('ok')}
        </Button>
      </Row>
    </div>
  );
};
